import { Box } from "@mui/material";
import RoleFilter from "./RoleFilter";
import LocationFilter from "./LocationFilter";
import ActiveRoleBundle from "./ActiveRoleBundle";

const RuleUnitFilter = () => {
  return (
    <Box>
      <RoleFilter></RoleFilter>
      <ActiveRoleBundle />
      <LocationFilter></LocationFilter>
    </Box>
  );
};

export default RuleUnitFilter;
